"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_analytics_1 = require("owa-analytics");
var owa_mail_compose_store_1 = require("owa-mail-compose-store");
var owa_mail_list_selection_orchestrator_1 = require("owa-mail-list-selection-orchestrator");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_mail_messagead_store_1 = require("owa-mail-messagead-store");
var mailModuleOrchestrator = require("owa-mail-module-orchestrator");
var MailListItemSelectionSource_1 = require("owa-mail-store/lib/store/schema/MailListItemSelectionSource");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_mail_messagead_list_store_1 = require("owa-mail-messagead-list-store");
/**
 * select message Ad orchestration
 */
exports.default = legacy_1.select({
    tableView: function () { return owa_mail_list_store_1.getSelectedTableView(); },
    messageAdStore: owa_mail_messagead_store_1.getStore,
    messageAdListViewStatusStore: function () { return owa_mail_messagead_list_store_1.messageAdListViewStatusStore; },
})(legacy_1.action('selectMessageAd')(function selectMessageAd(selectedAdId, selectMessageAdState) {
    var selectedMessageAd = selectMessageAdState.messageAdStore.messageAdRowStore.get(selectedAdId);
    if (selectedAdId && selectedMessageAd) {
        selectedMessageAd.isRead = true;
        owa_analytics_1.logUsage('SelectNativeAd', {
            adType: selectedMessageAd.adType,
            adMarket: selectedMessageAd.adMarket,
            adRefreshEvent: selectedMessageAd.adRefreshEvent,
        });
        // For one-click Ad, just open a window to the target Url without selecting the Ad and leave the reading pane as is before
        if (selectedMessageAd.adOneClickDirectTargetUrl) {
            window.open(selectedMessageAd.adOneClickDirectTargetUrl, '_blank');
            return;
        }
    }
    // Reset selection
    owa_mail_list_selection_orchestrator_1.MailListSelection.resetSelection(selectMessageAdState.tableView, MailListItemSelectionSource_1.default.MessageAd);
    selectMessageAdState.messageAdListViewStatusStore.selectedAdId = selectedAdId;
    // If compose form is opened, safely close it
    if (owa_mail_compose_store_1.composeStore.defaultViewState !== null) {
        owa_mail_compose_store_1.lazyTrySaveAndCloseCompose.importAndExecute(null /*viewState*/);
    }
    mailModuleOrchestrator.lazyOnSelectMessageAd.importAndExecute();
}));
//# sourceMappingURL=selectMessageAd.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-messagead-action/lib/actions/selectMessageAd.js
// module id = 6019
// module chunks = 67